import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FaTwitter } from 'react-icons/fa';

import { constructURLParams } from 'utils';
import event from 'utils/event';
import { TWITTER_BLUE } from 'root/theme';

import ShareButton from '../ShareButton';

export default class TwitterShareButton extends Component {
  onClick = (e) => {
    const {
      user,
      text,
      link,
      urlParams,
      source,
    } = this.props;

    e.preventDefault();
    let shareLink = link || `https://www.quizhive.com/referral/${user ? user.username : ``}`;
    shareLink = `${shareLink}?${constructURLParams(urlParams)}`;
    const shareText = `${text} ${shareLink}`;

    event(`share`, [`click`, `share-twitter`, source]);

    const params = encodeURIComponent(shareText);
    window.open(`https://twitter.com/intent/tweet?text=${params}`, `_blank`);
  }

  render() {
    return (
      <ShareButton
        background={ TWITTER_BLUE }
        onClick={ this.onClick }
        circle={ this.props.circle }
      >
        <FaTwitter size="1.5em" />
      </ShareButton>
    );
  }
}

TwitterShareButton.propTypes = {
  user: PropTypes.object,
  text: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  urlParams: PropTypes.object.isRequired,
  link: PropTypes.string,
  circle: PropTypes.bool,
};
